import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import React, { Fragment } from 'react';

import DonationCard from '@/core/components/DonationCard';
import { BannerSlot, useAdsContext } from '@/core/lib/ads/ads.context';
import DonationDomain from '@/core/lib/new-architecture/domain/donation.domain';

dayjs.extend(utc);
dayjs.locale('fr');

type DonationListProps = {
  donations: DonationDomain[];
};
export const DonationList: React.FC<DonationListProps> = ({ donations }) => {
  const { Ad } = useAdsContext();

  return (
    <div className="grid grid-cols-2 gap-4 lg:mt-7 lg:grid-cols-4 lg:gap-3">
      {donations.map((donation, index) => {
        return (
          <Fragment key={`${donation.data.donation.id}-Fragment`}>
            <div key={donation.data.donation.id} className="col-span-1">
              <DonationCard donation={donation} vertical hideUser />
            </div>
            {index > 0 && (index + 1) % 8 === 0 && (
              <section key={`${donation.data.donation.id}-ad`} className="col-span-2 flex items-center justify-center lg:col-span-4">
                <div className="hidden place-self-center md:col-span-8 min-[1296px]:flex">
                  <Ad size="728x90" slot={BannerSlot.DONNONS_PROFIL_MIDDLE} />
                </div>
                <div className="hidden place-self-center lg:col-span-8 lg:max-[1295px]:flex">
                  <Ad size="336x280" slot={BannerSlot.DONNONS_PROFIL_MIDDLE} />
                </div>
                <div className="col-span-4 hidden place-self-center min-[728px]:max-[1023px]:flex md:col-span-8">
                  <Ad size="728x90" slot={BannerSlot.DONNONS_PROFIL_MIDDLE} />
                </div>
                <div className="col-span-4 hidden place-self-center min-[336px]:max-[727px]:flex">
                  <Ad size="336x280" slot={BannerSlot.DONNONS_PROFIL_MIDDLE} />
                </div>
                <div className="col-span-4 hidden place-self-center min-[320px]:max-[335px]:flex">
                  <Ad size="320x100" slot={BannerSlot.DONNONS_PROFIL_MIDDLE} />
                </div>
                <div className="col-span-4 hidden place-self-center min-[300px]:max-[319px]:flex">
                  <Ad size="300x250" slot={BannerSlot.DONNONS_PROFIL_MIDDLE} />
                </div>
              </section>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};
